import { TextField } from '@mui/material';

const TextFilter = ({ filterOption, filterMenu, keyParam, onFieldChange, placeHolder }) => (
    <TextField
        id={keyParam}
        label={filterMenu[keyParam].title}
        fullWidth
        size='small'
        margin='normal'
        value={filterOption[keyParam] || ''}
        onChange={(e) => onFieldChange(keyParam, e.target.value)}
        slotProps={{ inputLabel: { shrink: true } }}
        variant='outlined'
        placeholder={placeHolder}
        sx={{ mt: 2.5,'& .MuiOutlinedInput-root': { borderRadius: '5px' } }}
    />
);

export default TextFilter;
